import React from 'react';

const Description = ({ title, text, truncateValue }) => {
  return (
    <div className='detail-description'>
      <label className='detail-description__label'>
        {title}
      </label>

      <span
        className='detail-description__value'
        title={truncateValue ? text : null}
      >
        {text}
      </span>
    </div>
  )
}

export default Description;
